<template>
    <div class="pm ">
        <el-row class="video-tree flex" >

            <el-col :span="treespan"  v-show="isright"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <product-tree ref="tree" @showData="showData"></product-tree>
            </el-col>
            <el-col :span="rightspan" id="tabelBox" style="height: 100%;min-width: 320px;width: 100%">
                <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>
                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_product_name')" v-model="vc_name">
                </el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_origin')" v-model="vc_cd">
                </el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_manufacturer')" v-model="vc_gykh">
                </el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_specification_model')" v-model="vc_bzstyle">
                </el-input>
                <el-input style="width: 120px" class="marr4" clearable size="mini" :placeholder="$t('yewuPM_material')" v-model="vc_material">
                </el-input>
                <el-select  style="width: 100px"  class="marr4" v-model="i_state" size="mini"  >
                    <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                    </el-option>
                </el-select>
        <el-button class="marB10" icon="el-icon-search" circle @click="searchFun " size="mini" ></el-button>
        <el-button class="marB10"  @click="addcpggFun('add')"  :class="baseerp+'btn'" size="mini">
            {{$t('button_newly_added')}}
        </el-button>
        <el-button class="marB10" @click="addcpggFun('edit')" :class="baseerp+'btn'" size="mini">{{$t('button_edit')}}</el-button>
        <el-button class="marB10"  @click="transferFun(null,'zycpgg')" :class="baseerp+'btn'" size="mini" >{{$t('yewuPM_transfer_product_specification')}}</el-button>

        <!--        <el-button class="marB10"  @click="tjspFun" :class="baseerp+'btn'" size="mini">-->
<!--            提交审批-->
<!--        </el-button>-->
        <el-table class="mrt10" ref="table" row-key="wyid" @row-click="chooseggFun"  @selection-change="handleSelectionChange"  size="mini" :height="tableHeight" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column  :selectable="selectable" :reserve-selection="true" align="center" type="selection" width="50px" ></el-table-column>
            <!--                    <el-table-column label="序号" align="center" type="index" width="50px"show-overflow-tooltip></el-table-column>-->
<!--            <el-table-column  align="center" type="selection" width="50px" show-overflow-tooltip></el-table-column>-->
            <el-table-column align="center" label="ID" prop="i_id" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_master_data_id')" prop="i_mdid" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_product_category_name')" prop="vc_pztype" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_product_name')" prop="vc_pzname" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_specification_name')" prop="vc_name" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_english_name')" prop="vc_ename" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_origin')" prop="vc_cd"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_manufacturer')" prop="vc_gykh"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_packaging_specification')" prop="vc_bzstyle"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_packaging_unit')" prop="vc_bzunit"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_conversion_ratio')" prop="f_bl"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_measurement_unit')" prop="vc_unit"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_single_net_weight')" prop="f_weight"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_weight_unit_per_piece')" prop="vc_djunit"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_product_attribute')" prop="i_flag">
                <template slot-scope="scope">
                    <div>{{flagList.find(f=>f.i_flag==scope.row.i_flag).vc_flag}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_goods_nature')" prop="vc_type"show-overflow-tooltip></el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_bulk_non_bulk')" prop="i_isbulk">
                <template slot-scope="scope">
                    <div>{{scope.row.i_isbulk==0?$t('yewuPM_non_bulk'):$t('yewuPM_bulk')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_sync_to_ecommerce_or_not')" prop="isec">
                <template slot-scope="scope">
                    <div>{{scope.row.isec?$t('form_correct'):$t('form_deny')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_piece_counting_or_not')" prop="isjian">
                <template slot-scope="scope">
                    <div>{{scope.row.isjian?$t('form_correct'):$t('form_deny')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_use_packaging_or_not')" prop="isusepack">
                <template slot-scope="scope">
                    <div>{{scope.row.isusepack?$t('form_correct'):$t('form_deny')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_enabled_or_not')" prop="isusepack">
                <template slot-scope="scope">
                    <div>{{scope.row.isuse?$t('form_correct'):$t('form_deny')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_mandatory_inspection_on_unloading_or_not')" prop="i_ismustcheck">
                <template slot-scope="scope">
                    <div>{{scope.row.i_ismustcheck?$t('form_correct'):$t('form_deny')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_assay_required_or_not')" prop="i_assayres">
                <template slot-scope="scope">
                    <div>{{scope.row.i_assayres?$t('form_correct'):$t('form_deny')}}</div>
                </template>
            </el-table-column>
            <el-table-column align="center" :label="$t('yewuPM_financial_cost_accounting')" prop="i_type_sel">
                        <template slot-scope="scope">
                            <div>{{scope.row.i_type_sel==1?'按批次':$t('yewuPM_by_product')}}</div>
                        </template>
                    </el-table-column>
<!--            <el-table-column align="center" label="ERP库存核算" prop="i_pzid_kcjs_sel">-->
<!--                <template slot-scope="scope">-->
<!--                    <div>{{scope.row.i_pzid_kcjs_sel?'规格ID':'大类ID'}}</div>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column align="center" :label="$t('yewuPM_erp_statistical_granularity')" prop="i_ispno">
                <template slot-scope="scope">
                    <div>{{scope.row.i_ispno==2?$t('yewuPM_specification'):$t('yewuPM_batch')}}</div>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination  style="margin-top: 10px;text-align: right"
                                background
                                @current-change="pageCurrentChange"
                                @size-change="sizeChange"
                                :page-sizes="pageSizes"
                                layout="total,sizes,prev, pager, next"
                                :current-page.sync="currentPage"
                                :total="total"
                                :page-size="pageSize">
                </el-pagination>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="cpggtitle"
                       width="90%"
                       class="minw840"
                       v-if="cpggVisible"
                       :visible.sync="cpggVisible"
                       :modal-append-to-body="false"
                       :close-on-click-modal="false">
                <chanpin-guige :data="cpggData" @close="cpggClose"></chanpin-guige>
            </el-dialog>
            <el-dialog :title="zycpggtitle" width="80%" class="minw840" v-if="zycpggVisible" :visible.sync="zycpggVisible" :modal-append-to-body="false" :close-on-click-modal="false">
                <transfer-cpgg :data="zycpggData" @close="zycpggClose"></transfer-cpgg>
            </el-dialog>

        </div>


    </div>

</template>

<script>
    import * as API from "./api"
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import ChanpinGuige from "./ChanpinGuige";
    import TransferCpgg from "./TransferCpgg";
    import ProductTree from "./ProductTree";

    export default {
        name: "index",
        components: {ChanpinGuige,TransferCpgg,ProductTree},
        data() {
            return {
                currentPage: 1,
                pageSize: 30,
                total:0,
                pageSizes:[30,100,200,300],
                tableData:[],
                tableHeight:0,//列表高度
                baseerp:'',
                cpggVisible:false,
                cpggData:{},
                cpggtitle:'',
                vc_name:'',
                vc_cd:"",
                vc_gykh:'',
                vc_bzstyle:'',
                vc_material:'',
                i_state:1,
                stateList:[{i_id:1,vc_name:this.$t('yewuPM_enabled')},{i_id:0,vc_name:this.$t('yewuPM_disabled')},],
                flagList:[],
                chooseggData:{},
                zycpggList:[],
                zycpggData:{},
                zycpggVisible:false,
                zycpggtitle:'',
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                treespan:4,
                rightspan:20,
                isright:true,//树显示按钮

            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },

        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })
            this.findClassificationAttributes();
            // this.getProductSpecification()

        },
        methods: {
            ...mapActions(["getCurrentMenuId"]),
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100

                // console.log(n.h)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            addcpggFun(type){
                let val={};
                if(type=='add'){
                    this.cpggData.type=type;
                    this.cpggtitle=this.$t('yewuPM_add_new_specification');
                }else{
                    if(this.chooseggData&&this.chooseggData.i_id){
                        val=this.chooseggData;
                        this.cpggData=val;
                        this.cpggData.type=type;

                        this.cpggtitle=this.$t('yewuPM_edit_specification')+'  ('+val.vc_name+')';
                    }else{
                        this.$message.warning(this.$t('yewuPM_please_click_the_specification_to_edit'));
                        return
                    }

                }
                this.cpggOpen()
            },
            chooseggFun(val){
                this.chooseggData=val
            },
            handleSelectionChange(val) {
                this.zycpggList = val;
                // this.chooseggData=null
            },
            transferFun(val,type){
                if(type=='zycpgg'){
                    if(this.zycpggList.length>0){
                        this.zycpggData={
                            list:this.zycpggList,
                            flagList:this.flagList
                        }
                        // console.log(this.zycpggList,'this.zycpggList')
                        this.zycpggtitle=this.$t('yewuPM_transfer_product_specifications');
                        this.zycpggOpen()
                    }else{
                        this.$message.warning('请勾选规格进行转移')
                    }
                }
            },
            zycpggOpen(){
                this.zycpggVisible=true;
            },
            zycpggClose(type='close'){
                if(type=='save'){
                    this.zycpggData=null
                    this.zycpggList=[]
                    this.$refs.table.clearSelection()
                    this.currentPage = 1
                    this.getProductSpecification()
                }
                this.zycpggVisible=false

            },
            // addFun(){
            //     this.cpggtitle='新增规格';
            //     this.cpggOpen()
            // },
            searchFun(){
                this.currentPage = 1;
                this.getProductSpecification()
            },
            tjspFun(){},
            cpggOpen(){
                this.cpggVisible=true
            },
            cpggClose(type='close'){
                if(type=='save'){
                    this.currentPage = 1;
                    this.getProductSpecification()
                }
                this.cpggVisible=false

            },
            async getProductSpecification(){
                // this.tableData=[]
                this.dataText=this.$t('tips_data_loading_in_progress')

                let param = {
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_name:this.vc_name,
                    vc_cd:this.vc_cd,
                    vc_gykh:this.vc_gykh,
                    vc_bzstyle:this.vc_bzstyle,
                    vc_material:this.vc_material,
                    isuse:this.i_state,
                    i_pzid:this.infomation.type==0?this.infomation.i_id:0,
                    i_pztypeid:this.infomation.type==1?this.infomation.i_id:this.infomation.i_typepid,

                };
                let res = await API.getProductSpecification(param);
                if (res.code == 1) {
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.tableData=res.data.list;
                    this.total=res.data.total;
                    this.tableData.map(t=>{
                        t.wyid=t.i_pztypeid+'-'+t.i_id
                    })
                    // this.pageSizes=this.getPageSizes(this.total);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            pageCurrentChange(val){
                // console.log(val,"pageval");
                this.currentPage=val;
                //调用列表接口
                this.getProductSpecification();
            },
            sizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                ///调用列表接口
                this.getProductSpecification();
            },
            getPageSizes(total){
                const max=Math.ceil(total/200);
                return  Array.from({length:max},(_, i)=> 200 * (i+1));
            },

            isRowSelectable(row,index){
                if(this.formData.i_bzid==1){
                    return true
                }else{
                    if(row.i_bzid===this.formData.i_bzid){
                        return true
                    }else{
                        return false
                    }
                }
            },

            selectable(row){
                if(row.i_syncyy_type==2){
                    if(this.zycpggList.length){
                        if(row.i_flag==this.zycpggList[0].i_flag){
                            return true
                        }else{
                            return false
                        }
                    }else{
                        return true
                    }
                }else{
                    return false
                }
            },
            async findClassificationAttributes(){
                let param={
                };
                let res=await API.findClassificationAttributes(param);
                if ( res.code == 1 ){
                    this.flagList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            showData(val){
                this.infomation=JSON.parse(JSON.stringify(val)) ;
                this.zycpggList=[]
                this.$refs.table.clearSelection()
                // console.log('this.infomation=',this.infomation)
                this.currentPage = 1;
                this.getProductSpecification();
            },
        },
    }
</script>

<style lang="scss" scoped>

    .flex{
        display: flex;
    }
    .p5{
        padding: 5px 0;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }

    .color409eff{
        color: var(--light) !important;
        display: inline-block;
    }
    /deep/{
        .minw840 .el-dialog{
            min-width: 840px;
        }
        .el-table .cell{
            padding-right: 2px;
            padding-left: 2px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table .el-button--text{
            color: #333;
        }
    }

    .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
        color: white;
    }
    .nopadding{
        padding: 5px 10px;
        i{
            vertical-align: center;
        }
    }
</style>